'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _reactJplayerUtils = require('react-jplayer-utils');
var _lodash = require('lodash.merge');
var _lodash2 = _interopRequireDefault(_lodash);
var _keyControl = require('./keyControl');
var _keyControl2 = _interopRequireDefault(_keyControl);
var _actions = require('../../../actions/actions');
var _getLoopState = require('../../../util/loop/getLoopState');
var _getLoopState2 = _interopRequireDefault(_getLoopState);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var jPlaylists = _ref.jPlaylists;
  var id = _ref2.id;
  return {
    loop: jPlaylists[id].loop
  };
};
var mergeProps = function mergeProps(stateProps, _ref3, _ref4) {
  var dispatch = _ref3.dispatch;
  var keyBindings = _ref4.keyBindings,
    children = _ref4.children,
    id = _ref4.id;
  return {
    keyBindings: (0, _lodash2.default)({
      next: {
        key: 221,
        // ]
        fn: function fn() {
          return dispatch((0, _actions.next)(id));
        }
      },
      previous: {
        key: 219,
        // [
        fn: function fn() {
          return dispatch((0, _actions.previous)(id));
        }
      },
      shuffle: {
        key: 83,
        // s
        fn: function fn() {
          return dispatch((0, _actions.shuffle)(id, undefined, true));
        }
      },
      loop: {
        key: 76,
        // l
        fn: function fn() {
          var loop = (0, _getLoopState2.default)(stateProps.loop);
          dispatch((0, _actions.setOption)(id, 'loop', loop));
        }
      }
    }, keyBindings),
    children: children
  };
};
exports.default = (0, _reactJplayerUtils.connectWithId)(mapStateToProps, null, mergeProps)(_keyControl2.default);